import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import WriteReviewModal from "../modal/WriteReviewModal";
import { useParksViewContext } from "provider/ParkViewProvider";
import GetQuoteForm from "components/safaritouroperator/GetQuoteForm";
import { useParams } from "react-router-dom";
import apiCall from "components/Api/api";

const ParkReview = () => {
  const { parkSlug } = useParams
  const { parkViewReviewModalToggle, parksViewDispatch } = useParksViewContext()
  const [loading, setLoading] = useState(false);
  
  const handleShow = () => {
    parksViewDispatch({ type: "SET_PARK_VIEW_REVIEW_MODAL_TOGGLE", payload: true });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiCall({
          url: `park/${parkSlug}/reviewlist?sort_by=highest`,
          method: "GET",
        });
        if (response?.status === 200) {
          if (response?.data?.errors) {
            const errors = response?.data.errors;
            // Dynamically set errors based on the response
            console.error(errors)
          } else {
            const postData = response?.data?.packages?.data || [];
            const summary = response?.data?.packages?.summary;

          }
        }

      } catch (err) {
        console.error("Error fetching safaris:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [parkSlug]);

  return (
    <>
      <div className="tab-content_tour mb-4 active">
        <Row className="row">
          <Col xs={12}>
            <Row>
              <Col xl={9} className="mb-4">
                <div className="comments_safari operator_comment bg-white">
                  <div className="commentsOther position-relative px-5 pt-4">
                    <div className="d-flex justify-content-between flex-wrap">
                      <div className="whiteReview mt-2">
                        <button
                          className="parkrevieBtn writeSuggestionBtn"
                          onClick={handleShow}
                        >
                          Write Review
                        </button>
                      </div>
                    </div>
                  </div>
                  <div id="review-list"></div>
                </div>
              </Col>
              <Col xl={3}>
                <GetQuoteForm />
              </Col>
            </Row>

          </Col>
        </Row>
      </div>
      {parkViewReviewModalToggle && <WriteReviewModal />}
    </>
  );
}

export default ParkReview;
